import { Menu, MenuItem, IconButton, Box, useTheme, alpha } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { MAIN_NAV_ITEMS } from '../config/navConfig';

const MobileNav = ({ anchorElNav, handleOpenNavMenu, handleCloseNavMenu, currentPath }) => {
  const theme = useTheme();

  return (
    <>
      <IconButton
        size="large"
        aria-label="menu"
        onClick={handleOpenNavMenu}
        sx={{
          color: '#ffffff',
          ml: 1,
          transition: 'transform 0.2s ease',
          '&:hover': {
            transform: 'rotate(90deg)',
            backgroundColor: theme => alpha(theme.palette.secondary.main, 0.1),
          }
        }}
      >
        <MenuIcon />
      </IconButton>
      <Menu
        id="mobile-menu"
        anchorEl={anchorElNav}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        keepMounted
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        open={Boolean(anchorElNav)}
        onClose={() => handleCloseNavMenu(null)}
        sx={{
          display: { xs: "block", md: "none" },
          '& .MuiPaper-root': {
            minWidth: 220,
            maxHeight: '30vh',
            overflow: 'auto',
            py: 0,
            mt: 1,
            borderRadius: 2,
            boxShadow: theme.shadows[3],
          }
        }}
        MenuListProps={{
          sx: {
            py: 0,
          }
        }}
      >
        {MAIN_NAV_ITEMS.map((item) => {
          const isActive = currentPath === item.path;

          return (
            <MenuItem
              key={item.name}
              onClick={() => handleCloseNavMenu(item)}
              sx={{
                py: 1.5,
                px: 2.5,
                my: 0.5,
                mx: 1,
                minHeight: 'auto',
                borderRadius: 1.5,
                backgroundColor: isActive
                  ? theme.palette.primary.main
                  : 'transparent',
                color: isActive
                  ? theme.palette.primary.contrastText
                  : theme.palette.text.primary,
                fontWeight: isActive ? 600 : 500,
                '&:hover': {
                  backgroundColor: isActive
                    ? theme.palette.primary.dark
                    : alpha(theme.palette.secondary.main, 0.15),
                  color: isActive
                    ? theme.palette.primary.contrastText
                    : theme.palette.text.primary,
                }
              }}
            >
              <Box sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 2,
              }}>
                {item.icon}
                {item.name}
              </Box>
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
};

export default MobileNav;